import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import HomeNavbar from './component/Navbar/HomeNavbar';
import AboutUs from './component/AboutUs/AboutUs';
import ContactUs from './component/ContactUs/ContactUs';
import HomePage from "./component/Home/HomePage"
import Footer from './component/Footer/Footer';
import Culturepage from './component/Culture/Culturepage';
import Career from './component/Career/Career';
import Leadership2 from './component/LeaderShip/Leadership2';
import Newsandevents from './component/News&Events/Newsandevents';
import Offerings2 from './component/Offerings2/Offerings2';
import IndividualPage from './component/IndividualPages/IndividualPages';
import SchedulePage from './component/SchedulePage/SchedulePage';
import Offerings from './component/Offerings/Offerings';
import ApplyIntoJobpage from './component/Career/ApplyIntoJobpage';

function App() {
  return (
    <div className="App" style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Router>
        <HomeNavbar/>
        <main style={{ flex: '1 1 auto', minHeight: '0' }}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/Offerings" element={<Offerings/>} />
            <Route path="/contactus" element={<ContactUs />} />
            <Route path="/leadership" element={<Leadership2 />} />
            <Route path="/culture" element={<Culturepage />} />
            <Route path="/career" element={<Career />} />
            <Route path="/career/apply" element={<ApplyIntoJobpage />} />  {/* ✅ Matches */}
            <Route path="/newsandevents" element={<Newsandevents />} />
            <Route path="/individualPages" element={<IndividualPage />} />
            <Route path="/schedulemetting" element={<SchedulePage />} />
            <Route path="*" element={
              <div style={{ padding: '2rem', textAlign: 'center' }}>
                <h2>404 - Page Not Found</h2>
                <p>The page you're looking for doesn't exist.</p>
                <Link to="/" style={{ textDecoration: 'underline' }}>Go back home</Link>
              </div>
            } />
          </Routes>
        </main>
        <Footer />
      </Router>
    </div>
  );
}

export default App;
